export enum WebCamIntegrationTypeEnum {
    NONE = 'NONE',
    LEFT = 'LEFT',
    CENTER = 'CENTER',
    RIGHT = 'RIGHT',
    LARGE_LEFT = 'LARGE_LEFT',
    LARGE_CENTER = 'LARGE_CENTER',
    LARGE_RIGHT = 'LARGE_RIGHT'
}
